import {Component, HostListener, OnInit} from '@angular/core';
import {RestapiService} from '../../../services/restapi.service';
import {Router} from '@angular/router';
import {FooterService} from '../../../services/footer.service';

@Component({
  selector: 'app-endlessblow',
  templateUrl: './endless-blow.component.html',
  styleUrls: ['./endless-blow.component.css']
})
export class EndlessBlowComponent implements OnInit {

  usersWithInfo: any;
  waitForResponseFromInfo1: string;
  footerHeight: number;

  constructor(private service: RestapiService, private router: Router, private footerService: FooterService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    setTimeout(() => {
       this.footerHeight = this.footerService.getFooterHeight();
     }, 500);
  }

  ngOnInit(): void {
    this.footerHeight = this.footerService.getFooterHeight();
  }

  doGetUsersInfo(): void {
    if (this.service.isLogged()) {

      const response = this.service.getUsersInfo(
        localStorage.getItem(this.service.USER_NAME_ATTRIBUTE_NAME),
        localStorage.getItem(this.service.PASSWORD_ATTRIBUTE_NAME));

      this.waitForResponseFromInfo1 = 'Wait for response';
      response.subscribe(data => {this.waitForResponseFromInfo1 = ''; this.usersWithInfo = data; },
          error => {this.waitForResponseFromInfo1 = ''; console.log(error); });
    }
    else {
      this.router.navigate(['/login']).then(nav => {console.log(nav); });
    }
  }
}
